import { css } from 'styled-components';
import token from 'styled-token';

/** @class PropertyCardHomeDetailsMixin */
/** @method */
export var PropertyCardHomeDetailsMixin = function PropertyCardHomeDetailsMixin() {
  return token({
    color: 'PropertyCard.data.pipeColor'
  }, function (_ref) {
    var color = _ref.color;
    return css(["&:not(:last-child):after,span:not(:last-child):after{content:' | ';color:", ";}"], color);
  });
};